export const leadImages = {
  flag_icon: 'assets/img/graphics/Flag-icon.svg',
  flag_icon_v2: 'assets/img/lead-overview/flag@2x.png',
  email_lite_icon: 'assets/img/lead-overview/email-lite@2x.png',
  launch_icon: 'assets/img/lead-overview/lunch@2x.png',
  lead_1_icon: 'assets/menu-customisation-icons/Lead/lead1.svg',
  lead_2_icon: 'assets/menu-customisation-icons/Lead/lead2.svg',
  lead_3_icon: 'assets/menu-customisation-icons/Lead/lead3.svg',
  lead_4_icon: 'assets/menu-customisation-icons/Lead/lead4.svg',
  lead_5_icon: 'assets/menu-customisation-icons/Lead/lead5.svg',
};
